import {NgModule} from '@angular/core';
import {RestaurantInfoComponent} from './restaurant-info/restaurant-info';
import {HeaderComponent} from './header/header';
import {SchedulerComponent} from './scheduler/scheduler';
import {GenericModalComponent} from './generic-modal/generic-modal';
import {UserInfoComponent} from './user-info/user-info';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PasswordStrengthBarModule} from 'ng2-password-strength-bar';
import {TranslateModule} from '@ngx-translate/core';
import {SetWorkPeriodComponent} from './set-work-period/set-work-period';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {ContractModalComponent} from './contract-modal/contract-modal';
import {ColorThemeModalComponent} from './color-theme-modal/color-theme-modal';
import {ColorPickerComponent} from './color-picker/color-picker.component';
import {CategoryCardComponent} from './category-card/category-card.component';
import {CategoryAddEditModalComponent} from './category-add-edit-modal/category-add-edit-modal.component';
import {ItemAddEditModalComponent} from './item-add-edit-modal/item-add-edit-modal.component';
import {OptionAddEditComponent} from './option-add-edit/option-add-edit.component';
import {OptionListComponent} from './option-list/option-list.component';
import {OptionAddEditModalComponent} from './option-add-edit-modal/option-add-edit-modal.component';
import {CategoryListComponent} from './category-list/category-list.component';
import {OptionSelectModalComponent} from './option-select-modal/option-select-modal.component';
import {DatetimePickerComponent} from './datetime-picker/datetime-picker.component';
import {MenuComponent} from './menu/menu.component';
import {WeightSelectModalComponent} from './weight-select-modal/weight-select-modal.component';
import {SelectOptionComponent} from './select-option/select-option.component';
import {OrderResumeComponent} from "./order-resume/order-resume";
import {WorkingPeriodsComponent} from "./working-periods/working-periods.component";
import {DataModalComponent} from "./data-modal/data-modal";
import {DriversModalComponent} from "./drivers-modal/driver-modal";

const components = [
  RestaurantInfoComponent,
  SchedulerComponent,
  GenericModalComponent,
  UserInfoComponent,
  HeaderComponent,
  SetWorkPeriodComponent,
  ContractModalComponent,
  ColorThemeModalComponent,
  ColorPickerComponent,
  CategoryCardComponent,
  CategoryListComponent,
  CategoryAddEditModalComponent,
  ItemAddEditModalComponent,
  OptionAddEditComponent,
  OptionListComponent,
  OptionAddEditModalComponent,
  OptionSelectModalComponent,
  DatetimePickerComponent,
  MenuComponent,
  WeightSelectModalComponent,
  SelectOptionComponent,
  OrderResumeComponent,
  WorkingPeriodsComponent,
  DataModalComponent,
  DriversModalComponent
];

@NgModule({
  declarations: components,
  imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PasswordStrengthBarModule,
        TranslateModule,
        IonicModule.forRoot()
    ],
  exports: components,
    entryComponents: components
})
export class ComponentsModule {}
